import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';

import { variables } from '../../../variables/variables';

@Injectable({
  providedIn: 'root',
})
export class BrowserFingerprintService {
  private readonly storageKey = variables.browserFingerprintStorageKey;
  private cachedFingerprint: string | null = null;
  private platformId: object = inject(PLATFORM_ID);

  getFingerprint(): string {
    if (!isPlatformBrowser(this.platformId)) {
      return '';
    }

    if (this.cachedFingerprint) {
      return this.cachedFingerprint;
    }

    let fingerprint = '';

    try {
      const existing = window.localStorage.getItem(this.storageKey);
      if (existing) {
        fingerprint = existing;
      } else {
        fingerprint = this.generateFingerprint();
        window.localStorage.setItem(this.storageKey, fingerprint);
      }
    } catch {
      fingerprint = this.generateFingerprint();
    }

    this.cachedFingerprint = fingerprint;
    return fingerprint;
  }

  private generateFingerprint(): string {
    try {
      if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
        return (crypto as any).randomUUID();
      }
    } catch {}

    return `${Date.now().toString(36)}-${Math.random().toString(36).substring(2, 10)}-${Math.random()
      .toString(36)
      .substring(2, 10)}`;
  }
}
